export default "__VITE_ASSET__BgTZKcfZ__"